import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

class Expired extends PureComponent {
	render() {
		const { message } = this.props;

		return (
			<div className="flex flex-align-items-center padding-20 bg-yellow-golden-tainoi-10 margin-top-30 margin-bottom-30">
				<div className="margin-right-30">
					<i className="rkf rkf-invoice font-size-40 color-yellow-golden-tainoi" />
				</div>
				<div>{ message || 'The job has expired' }</div>
			</div>
		);
	}
}

Expired.propTypes = {
	message : PropTypes.object,
};

Expired.defaultProps = {
	message : null,
};

export default Expired;
